export const getToday = (): string => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export class FamilyEvent {
  id = 0;
  userId = 0;
  eventDate = "";
  eventType = "";
  eventKind = "";
  eventRole = "";
  recipient = "";
  relation = "";
  receiver = "";
  amount = 0;
  amountType = "";
  location = "";
  memo = "";
  createDatetime = "";
  updateDatetime = "";
}

export class FamilyEventRequest {
  eventDate: string | null = getToday();
  eventType = "HAPPY";
  eventKind = "";
  eventRole = "SENT";
  recipient = "";
  relation = "";
  receiver = "";
  amount: number | null = null;
  amountType = "CASH";
  location = "";
  memo = "";

  public reset() {
    this.eventDate = getToday();
    this.eventType = "HAPPY";
    this.eventKind = "";
    this.eventRole = "SENT";
    this.recipient = "";
    this.relation = "";
    this.receiver = "";
    this.amount = null;
    this.amountType = "CASH";
    this.location = "";
    this.memo = "";
  }

  public bindFromEvent(event: FamilyEvent) {
    this.eventDate = event.eventDate;
    this.eventType = event.eventType;
    this.eventKind = event.eventKind;
    this.eventRole = event.eventRole;
    this.recipient = event.recipient;
    this.relation = event.relation;
    this.receiver = event.receiver;
    this.amount = event.amount;
    this.amountType = event.amountType;
    this.location = event.location;
    this.memo = event.memo;
  }
}

export const EVENT_TYPE_OPTIONS = [
  { value: "HAPPY", label: "경사" },
  { value: "SAD", label: "조사" },
];

export const EVENT_KIND_OPTIONS = [
  { value: "WEDDING", label: "결혼식" },
  { value: "BIRTHDAY", label: "생일" },
  { value: "FIRST_BIRTHDAY", label: "돌잔치" },
  { value: "FUNERAL", label: "장례식" },
  { value: "MEMORIAL", label: "기념일" },
  { value: "SIXTIETH", label: "환갑" },
  { value: "SEVENTIETH", label: "칠순" },
  { value: "HOUSEWARMING", label: "집들이" },
  { value: "ETC", label: "기타" },
];

export const EVENT_ROLE_OPTIONS = [
  { value: "RECEIVED", label: "받음" },
  { value: "SENT", label: "보냄" },
];

export const AMOUNT_TYPE_OPTIONS = [
  { value: "CASH", label: "현금" },
  { value: "GIFT", label: "선물" },
];

// Reverse maps: Korean label → enum value (for Excel import)
const buildReverseMap = (options: { value: string; label: string }[]): Record<string, string> => {
  const map: Record<string, string> = {};
  options.forEach((o) => {
    map[o.label] = o.value;
  });
  return map;
};

export const LABEL_TO_EVENT_TYPE = buildReverseMap(EVENT_TYPE_OPTIONS);
export const LABEL_TO_EVENT_KIND = buildReverseMap(EVENT_KIND_OPTIONS);
export const LABEL_TO_EVENT_ROLE = buildReverseMap(EVENT_ROLE_OPTIONS);
export const LABEL_TO_AMOUNT_TYPE = buildReverseMap(AMOUNT_TYPE_OPTIONS);

export const getEventKindLabel = (value: string): string => {
  return EVENT_KIND_OPTIONS.find((o) => o.value === value)?.label ?? value;
};

export const getEventTypeLabel = (value: string): string => {
  return EVENT_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;
};

export const getEventRoleLabel = (value: string): string => {
  return EVENT_ROLE_OPTIONS.find((o) => o.value === value)?.label ?? value;
};

export const getAmountTypeLabel = (value: string): string => {
  return AMOUNT_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;
};
